(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-frequently-bought-together"] && !Shopify.designMode) return;
  try {
    
	class CartFrequentlyBoughtTogether extends HTMLElement {
		constructor() {
			super();

			// Whether .cart-fbt__content currently holds real recommendation markup
			// (as opposed to being empty, either because nothing has loaded yet or
			// because Shopify had nothing to recommend for the current product).
			this.loaded = false;

			this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
				if (event.source === 'cart-frequently-bought-together') return;
				this.refreshBasisProduct();
			});
		}

		connectedCallback() {
			// Always fetch on first connect: the server-rendered content is only
			// non-empty when this request itself hit the recommendations route
			// with a product_id (it normally doesn't on a plain page load), so
			// .cart-fbt__content starts out empty and needs its own round trip.
			this.refreshBasisProduct();

			CartFrequentlyBoughtTogether.instances.add(this);

			// Fallback safety net, same reasoning as cart-similar-products.liquid:
			// this theme's add-to-cart flow doesn't reliably fire the cart-update
			// pub/sub event from every entry point, so poll while the tab is
			// visible to guarantee this stays in sync within a few seconds
			// regardless of which path was used.
			this.pollTimer = window.setInterval(() => {
				if (document.visibilityState === 'visible') {
					this.refreshBasisProduct();
				}
			}, 4000);
		}

		disconnectedCallback() {
			if (this.cartUpdateUnsubscriber) {
				this.cartUpdateUnsubscriber();
			}

			if (this.pollTimer) {
				window.clearInterval(this.pollTimer);
			}

			CartFrequentlyBoughtTogether.instances.delete(this);
		}

		refreshBasisProduct() {
			fetch(`${routes.cart_url}.js`, { cache: 'no-store' })
				.then((response) => response.json())
				.then((cart) => {
					if (!cart.items.length) {
						this.hidden = true;
						return;
					}

					let lastAddedProductId = null;
					try {
						lastAddedProductId = sessionStorage.getItem('lastAddedProductId');
					} catch (e) {}

					const stillInCart = lastAddedProductId && cart.items.some(
						(item) => String(item.product_id) === lastAddedProductId
					);
					const newProductId = stillInCart
						? lastAddedProductId
						: String(cart.items[cart.items.length - 1].product_id);

					this.hidden = false;

					// Re-fetch when the basis product changed, or when it's the same
					// but nothing has successfully loaded yet (first connect, or a
					// prior fetch/fallback came back empty).
					if (newProductId === this.dataset.basisProductId && this.loaded) {
						return;
					}

					this.dataset.basisProductId = newProductId;
					this.fetchRecommendations(newProductId, 'complementary');
				})
				.catch((e) => {
					console.error(e);
				});
		}

		fetchRecommendations(productId, intent, isFallback = false) {
			const url = `${this.dataset.recommendationsUrl}?section_id=${this.dataset.sectionId}&product_id=${productId}&limit=${this.dataset.limit}&intent=${intent}`;

			fetch(url)
				.then((response) => response.text())
				.then((text) => {
					const doc = new DOMParser().parseFromString(text, 'text/html');
					const fresh = doc.querySelector('.cart-fbt__content');

					if (fresh && fresh.innerHTML.trim().length) {
						const content = this.querySelector('.cart-fbt__content');
						if (content) content.innerHTML = fresh.innerHTML;
						this.loaded = true;
						this.initInteractions();
						return;
					}

					// "complementary" recommendations require real order history and
					// are often sparse or empty, especially on stores/products with
					// little purchase data. Retry once with "related" (tags/type/
					// vendor based, almost always has results) instead of leaving
					// the widget empty.
					if (!isFallback && intent === 'complementary') {
						this.fetchRecommendations(productId, 'related', true);
						return;
					}

					// Nothing to show even after the fallback — leave .cart-fbt__content
					// empty, but mark this basis product as resolved so the 4s poll
					// doesn't keep re-fetching the same empty result forever.
					this.loaded = true;
				})
				.catch((e) => {
					console.error(e);
				});
		}

		initInteractions() {
			const row = this.querySelector('.cart-fbt__row');
			const summary = this.querySelector('.cart-fbt__summary');
			if (!row || !summary) return;

			this.updateTotal();

			row.addEventListener('change', (event) => {
				if (event.target.matches('.cart-fbt__checkbox')) {
					this.updateTotal();
				}
			});

			const addButton = summary.querySelector('[data-add-button]');
			if (addButton) {
				addButton.addEventListener('click', () => this.handleAddClick());
			}
		}

		updateTotal() {
			const row = this.querySelector('.cart-fbt__row');
			const summary = this.querySelector('.cart-fbt__summary');
			if (!row || !summary) return;

			const checked = Array.from(row.querySelectorAll('.cart-fbt__checkbox:checked'));
			const total = checked.reduce((sum, checkbox) => sum + Number(checkbox.dataset.price), 0);

			const totalElement = summary.querySelector('[data-total]');
			if (totalElement) totalElement.textContent = formatMoney(total);

			const addButton = summary.querySelector('[data-add-button]');
			if (addButton) addButton.toggleAttribute('aria-disabled', checked.length === 0);
		}

		handleAddClick() {
			const row = this.querySelector('.cart-fbt__row');
			const summary = this.querySelector('.cart-fbt__summary');
			if (!row || !summary) return;

			const checked = Array.from(row.querySelectorAll('.cart-fbt__checkbox:checked'));
			if (!checked.length) return;

			const items = checked.map((checkbox) => ({
				id: Number(checkbox.dataset.variantId),
				quantity: 1
			}));

			const addButton = summary.querySelector('[data-add-button]');
			const errorElement = summary.querySelector('[data-error]');
			if (errorElement) errorElement.hidden = true;
			if (addButton) {
				addButton.setAttribute('aria-disabled', 'true');
				addButton.classList.add('loading');
				const spinner = addButton.querySelector('.loading-overlay__spinner');
				if (spinner) spinner.classList.remove('hidden');
			}

			const cartItemsElement = document.querySelector('cart-items');
			const sectionsToRender = cartItemsElement ? cartItemsElement.getSectionsToRender() : [];

			const config = fetchConfig();
			config.body = JSON.stringify({
				items,
				sections: sectionsToRender.map((section) => section.section),
				sections_url: window.location.pathname
			});

			fetch(`${routes.cart_add_url}`, config)
				.then((response) => response.json())
				.then((response) => {
					if (response.status) {
						if (errorElement) {
							errorElement.textContent = response.description || window.cartStrings.error;
							errorElement.hidden = false;
						}
						return;
					}

					sectionsToRender.forEach((section) => {
						const container = document.getElementById(section.id);
						if (!container || !response.sections[section.section]) return;

						const target = container.querySelector(section.selector) || container;
						const doc = new DOMParser().parseFromString(response.sections[section.section], 'text/html');
						const replacement = doc.querySelector(section.selector) || doc.body;
						target.innerHTML = replacement.innerHTML;
					});

					publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-frequently-bought-together' });
				})
				.catch((e) => {
					console.error(e);
					if (errorElement) {
						errorElement.textContent = window.cartStrings.error;
						errorElement.hidden = false;
					}
				})
				.finally(() => {
					if (addButton) {
						addButton.classList.remove('loading');
						addButton.removeAttribute('aria-disabled');
						const spinner = addButton.querySelector('.loading-overlay__spinner');
						if (spinner) spinner.classList.add('hidden');
					}
				});
		}
	}

	CartFrequentlyBoughtTogether.instances = new Set();

	// bfcache restores (browser back/forward) resume the page's JS as-is without
	// re-running element constructors/connectedCallback, so a stale basis product
	// baked into the DOM before the tab was cached would otherwise never refresh.
	window.addEventListener('pageshow', () => {
		CartFrequentlyBoughtTogether.instances.forEach((instance) => instance.refreshBasisProduct());
	});

	customElements.define('cart-frequently-bought-together', CartFrequentlyBoughtTogether);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-similar-products"] && !Shopify.designMode) return;
  try {
    
	class CartSimilarProducts extends HTMLElement {
		constructor() {
			super();

			this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
				this.refreshBasisProduct();
			});
		}

		connectedCallback() {
			// Self-correct on every real render, in case the server-rendered basis
			// product is stale (e.g. this cart type reloads /cart via window.location
			// on every add-to-cart, which never fires the cart-update pub/sub event).
			this.refreshBasisProduct();

			// Catch the *first* natural AJAX swap too (the SSR-rendered
			// <product-recommendations> fetching its own content via global.js's
			// IntersectionObserver) — refreshBasisProduct() only observes swaps
			// it itself triggers via replaceWith, not this initial one.
			const initialRecommendations = this.querySelector('product-recommendations');
			if (initialRecommendations) {
				const initialLoadObserver = new MutationObserver(() => {
					initialLoadObserver.disconnect();
					this.initMobileSlider();
					document.dispatchEvent(new Event('shopify:section:load'));
				});
				initialLoadObserver.observe(initialRecommendations, { childList: true });
			}

			CartSimilarProducts.instances.add(this);

			// Fallback safety net: this theme's add-to-cart flow doesn't reliably
			// publish cart-update for every entry point (varies by cart type / where
			// the add happens), so poll while the tab is visible to guarantee this
			// stays in sync within a few seconds regardless of which path was used.
			this.pollTimer = window.setInterval(() => {
				if (document.visibilityState === 'visible') {
					this.refreshBasisProduct();
				}
			}, 4000);
		}

		disconnectedCallback() {
			if (this.cartUpdateUnsubscriber) {
				this.cartUpdateUnsubscriber();
			}

			if (this.pollTimer) {
				window.clearInterval(this.pollTimer);
			}

			CartSimilarProducts.instances.delete(this);
		}

		refreshBasisProduct() {
			fetch(`${routes.cart_url}.js`, { cache: 'no-store' })
				.then((response) => response.json())
				.then((cart) => {
					if (!cart.items.length) {
						this.hidden = true;
						return;
					}

					// cart.items array order is not guaranteed to reflect add
					// order, so prefer the id recorded at the actual moment of
					// adding (see product-form.js), falling back to the last
					// array item only if nothing was recorded yet, or if that
					// recorded product was since removed from the cart.
					let lastAddedProductId = null;
					try {
						lastAddedProductId = sessionStorage.getItem('lastAddedProductId');
					} catch (e) {}

					const stillInCart = lastAddedProductId && cart.items.some(
						(item) => String(item.product_id) === lastAddedProductId
					);
					const newProductId = stillInCart
						? lastAddedProductId
						: String(cart.items[cart.items.length - 1].product_id);

					if (newProductId === this.dataset.basisProductId) {
						this.hidden = false;
						return;
					}

					this.dataset.basisProductId = newProductId;
					this.hidden = false;

					const url = `${this.dataset.recommendationsUrl}?section_id=${this.dataset.sectionId}&product_id=${newProductId}&limit=${this.dataset.limit}`;
					const fresh = document.createElement('product-recommendations');
					fresh.classList.add('product-recommendations');
					fresh.dataset.url = url;

					// product-slider.js only initializes Swiper via a one-time
					// bootstrap at page load, and intentionally skips mobile
					// widths entirely (see initMobileSlider below). Once new
					// recommendation markup is injected (async, inside the
					// ProductRecommendations element itself), (re)initialize it.
					const sliderInitObserver = new MutationObserver(() => {
						sliderInitObserver.disconnect();
						this.initMobileSlider();
						document.dispatchEvent(new Event('shopify:section:load'));
					});
					sliderInitObserver.observe(fresh, { childList: true });

					const existing = this.querySelector('product-recommendations');
					if (existing) {
						existing.replaceWith(fresh);
					} else {
						this.appendChild(fresh);
					}
				})
				.catch((e) => {
					console.error(e);
				});
		}

		// assets/product-slider.js intentionally never initializes Swiper below
		// 768px (mobile falls back to a static grid there, site-wide). This
		// section wants a real swipeable slider on mobile too, so — without
		// touching that shared file/behavior for every other slider on the
		// site — mirror its Swiper config here, scoped to just this section,
		// filling in exactly the width range product-slider.js skips.
		initMobileSlider() {
			if (window.innerWidth >= 768) return;

			const slider = this.querySelector('.products-slider');
			if (!slider) return;

			const sliderRoot = slider.querySelector('.products-slider__swiper.swiper');
			if (!sliderRoot || sliderRoot.swiper) return;

			const perRow = Number(slider.dataset.perRow) || 2;
			const mobile = Number(slider.dataset.mobile) || 1;
			const speed = Number(slider.dataset.speed) * 1000;
			const delay = Number(slider.dataset.delay) * 1000;
			const autoplay = slider.dataset.autoplay === 'true';
			const stopAutoplay = slider.dataset.stopAutoplay === 'true';
			const showArrows = slider.dataset.showArrows === 'true';
			const sectionId = slider.dataset.id;

			let autoplayParm = {};
			if (autoplay) {
				autoplayParm = {
					autoplay: { delay: delay, pauseOnMouseEnter: stopAutoplay, disableOnInteraction: false },
				};
			}

			let arrowsParm = {};
			if (showArrows) {
				arrowsParm = {
					navigation: {
						nextEl: `#${sectionId} .swiper-button-next`,
						prevEl: `#${sectionId} .swiper-button-prev`,
					},
					pagination: {
						el: `#${sectionId} .swiper-pagination`,
						clickable: true,
					},
				};
			}

			new Swiper(sliderRoot, {
				speed: speed,
				keyboard: true,
				slidesPerView: mobile,
				breakpoints: {
					576: { slidesPerView: perRow >= 2 ? 2 : 1 },
					750: { slidesPerView: perRow >= 3 ? 3 : perRow },
					990: { slidesPerView: perRow >= 4 ? 4 : perRow },
					1150: { slidesPerView: perRow },
				},
				mousewheel: { forceToAxis: true },
				...arrowsParm,
				...autoplayParm,
			});

			// Prevent product-slider.js's own bootstrap from also trying to
			// initialize this same slider if the viewport is later resized
			// past 768px.
			slider.classList.add('slider_started');
		}
	}

	CartSimilarProducts.instances = new Set();

	// bfcache restores (browser back/forward) resume the page's JS as-is without
	// re-running element constructors/connectedCallback, so a stale basis product
	// baked into the DOM before the tab was cached would otherwise never refresh.
	window.addEventListener('pageshow', () => {
		CartSimilarProducts.instances.forEach((instance) => instance.refreshBasisProduct());
	});

	customElements.define('cart-similar-products', CartSimilarProducts);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      button: this.querySelector("button"),
      panel: this.querySelector("ul"),
    };
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.elements.button.addEventListener("click", this.togglePanel.bind(this));
    this.addEventListener("keydown", this.onEscapePress.bind(this));
    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }
  connectedCallback() { document.addEventListener("click", this.handleDocumentClick); }
  disconnectedCallback() { document.removeEventListener("click", this.handleDocumentClick); }
  handleDocumentClick(event) { if (!this.contains(event.target)) this.hidePanel(); }
  hidePanel() {
    this.elements.button.setAttribute("aria-expanded", "false");
    this.elements.panel.setAttribute("hidden", true);
  }
  showPanel() {
    this.elements.button.setAttribute("aria-expanded", "true");
    this.elements.panel.removeAttribute("hidden");
  }
  togglePanel() {
    if (this.elements.button.getAttribute("aria-expanded") === "true") this.hidePanel();
    else this.showPanel();
  }
  onEscapePress(event) { if (event.key === "Escape") this.hidePanel(); }
  onItemClick(event) {
    event.preventDefault();
    this.elements.input.value = event.currentTarget.dataset.value;
    this.querySelector("form")?.submit();
    this.hidePanel();
  }
}
if (!customElements.get("localization-form")) {
  customElements.define("localization-form", LocalizationForm);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerInner = document.querySelector('.header');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
		
		if (this.headerIsAlwaysSticky) this.reveal; 
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
		this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
		this.header.style.transform = 'translateY(-100%)';
	};

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
		this.header.style.transition = 'background var(--duration-short), transform var(--duration-default)';
		this.header.style.transform = 'translateY(0)';
	};

	if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
		this.header.classList.remove('shopify-section-header-sticky');
		this.header.style.transform = 'translateY(0)';
		this.header.style.transition = 'background var(--duration-short)';
	};

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (this.preventHide) return;
		requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (!this.preventReveal) {
		requestAnimationFrame(this.reveal.bind(this));
		} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
			this.disclosures.forEach(disclosure => {
				disclosure.close(); 
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
				this.disclosureLists.forEach(disclosureList => {
					disclosureList.setAttribute('hidden', true); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }
	class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then(response => response.text())
				.then(text => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations--single');
					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
					}
				})
				.catch(e => {
					console.error(e);
				});
		}

		new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
	}
}

customElements.define('product-modal', ProductModal);
customElements.define('product-recommendations--single', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
